import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.onlinepanel');
import { OnInit, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { getStatusColor, getStatusLabel } from "src/libs/portal/metaverse/types";

@Component({
    selector: 'wiz-component-onlinepanel',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.onlinepanel/view.scss */
:host {
  display: block;
}

@keyframes onlinePanelIn {
  from {
    opacity: 0;
    transform: translateY(-0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes onlinePanelOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-0.25rem) scale(0.98);
  }
}
.online-panel {
  animation: onlinePanelIn 0.15s ease-out;
}

.online-panel-closing {
  animation: onlinePanelOut 0.25s ease-out forwards;
}

.online-player-list::-webkit-scrollbar {
  width: 0.25rem;
}
.online-player-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
}

@media (max-width: 768px) {
  .online-counter {
    transform: scale(0.85);
    transform-origin: top left;
  }
  .online-panel {
    max-height: 10.625rem !important;
    width: 11.25rem !important;
  }
}`],
})
export class ComponentOnlinepanelComponent implements OnInit {
    @Input() onlineCount: number = 1;
    @Input() players: any[] = [];
    @Input() mySid: string = '';
    @Input() isMobile: boolean = false;
    @Output() playerClick = new EventEmitter<any>();
    @Output() closeOtherDropdowns = new EventEmitter<void>();
    @ViewChild('panelBox') panelBoxRef: any;

    public showOnlinePanel: boolean = false;
    public isOnlinePanelClosing: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private elementRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    @HostListener('document:mousedown', ['$event'])
    onDocumentMouseDown(event: MouseEvent) {
        if (!this.showOnlinePanel || this.isOnlinePanelClosing) return;
        const panelEl = this.panelBoxRef?.nativeElement;
        if (panelEl && panelEl.contains(event.target)) return;
        this.closePanel();
    }

    public async toggleOnlinePanel() {
        if (this.showOnlinePanel) {
            this.closePanel();
        } else {
            this.closeOtherDropdowns.emit();
            this.showOnlinePanel = true;
            await this.service.render();
        }
    }

    public async onPlayerClick(player: any) {
        this.playerClick.emit(player);
        this.showOnlinePanel = false;
        this.isOnlinePanelClosing = false;
        await this.service.render();
    }

    public async closePanel() {
        if (!this.showOnlinePanel || this.isOnlinePanelClosing) return;
        this.isOnlinePanelClosing = true;
        await this.service.render();
        setTimeout(async () => {
            this.showOnlinePanel = false;
            this.isOnlinePanelClosing = false;
            await this.service.render();
        }, 250);
    }

    public getStatusColor(status: string): string { return getStatusColor(status); }
    public getStatusLabel(status: string): string { return getStatusLabel(status); }
}

export default ComponentOnlinepanelComponent;